<div class="row data-card">
    <div class="col">
        <div class="card mb-0">
            <div class="card-body p-3">
                <div class="d-flex gap-01 gap-sm-2 text-truncate">
                    <div id="chart">
                        <apx-chart
                            [series]="chartOptions.series"
                            [chart]="chartOptions.chart"
                            [plotOptions]="chartOptions.plotOptions"
                            [labels]="chartOptions.labels"
                            [legend]="chartOptions.legend"
                            [colors]="chartOptions.colors"
                            
                          ></apx-chart>
                        </div>
                        
                    <div class="">
                        <div class="d-flex flex-column">
                            <span class="fw-bold">{{ label === 'Total earnings' ? ('$' + (ammount || '0')) : (ammount || '0') }}</span>
                            <span class="font-14 text-light-grey">{{label?label:'NA'}}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>